var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notice_status!=null)?_c('span',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.noticeStatusText,"placement":"top-start"}},[_c('i',{staticClass:"el-icon-message",class:_vm.noticeClass})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }